import { mapGetters } from 'vuex';
import { userTypeMixins } from "@/core/Mixins"

export const SubscriptionsMixins = {
  mixins: [userTypeMixins],
  computed: {
    ...mapGetters({
      myClassroom: 'ClassroomModule/getClassroomData',
      userData: 'UserModule/getUser',
    })
  }
}
